import { useState } from 'react';
import Modal from '../modal/Modal';
import { useModal } from '../modal/useModal';
import { showErrorNotification } from '../../util/notifications';
import useApi from '../../api';
import classNames from 'classnames';
import { useQueryClient } from 'react-query';
import { QueryKey } from '../../constants/queryKey';

const DeleteUserModal = ({ modalId, user }) => {
    const { closeModal } = useModal();
    const { deleteUser } = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const queryClient = useQueryClient();

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    const onDeleteClick = async () => {
        setIsLoading(true);
        try {
            await deleteUser(user.id);
            await queryClient.invalidateQueries(QueryKey.Users);
        } catch (err) {
            const msg = err.response?.data?.error || 'Something went wrong deleting the user.';
            showErrorNotification(msg);
        }
        closeModal(modalId);
    };

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Delete user</h1>
            Are you sure you want to delete <strong>{user.email}</strong>?
            <div className="modal__footer">
                <button className="button button--link" onClick={() => closeModal(modalId)}>Cancel</button>
                <button className={buttonClass} onClick={onDeleteClick}>Delete</button>
            </div>
        </Modal>
    );
};

export default DeleteUserModal;
